import { Reservation } from './types';

export const getNext30MinSlotStart = (now: Date): Date => {
  const d = new Date(now);
  const minutes = d.getMinutes();
  let startMinutes: number;
  let addHours = 0;
  if (minutes <= 15) {
    startMinutes = 0;
  } else if (minutes <= 40) {
    startMinutes = 30;
  } else {
    startMinutes = 0;
    addHours = 1;
  }
  d.setMinutes(startMinutes, 0, 0);
  if (addHours) d.setHours(d.getHours() + addHours);
  return d;
};

export const getNextAvailableSlot = (
  date: Date,
  reservationsList: Reservation[],
  roomId: string,
  dayStartHour: number,
  dayEndHour: number
): { startTime: Date; endTime: Date } | null => {
  const dayReservations = reservationsList.filter((r) => {
    const start = new Date(r.startTime);
    return r.room.id === roomId &&
      start.getFullYear() === date.getFullYear() &&
      start.getMonth() === date.getMonth() &&
      start.getDate() === date.getDate();
  });

  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dateIsToday = date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate();

  const dateNorm = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  if (dateIsToday) {
    let slotStart = getNext30MinSlotStart(now);
    const slotStartHour = slotStart.getHours() + slotStart.getMinutes() / 60;
    if (slotStartHour < dayStartHour) {
      slotStart = new Date(dateNorm);
      slotStart.setHours(dayStartHour, 0, 0, 0);
    } else {
      slotStart = new Date(dateNorm.getFullYear(), dateNorm.getMonth(), dateNorm.getDate(), slotStart.getHours(), slotStart.getMinutes());
    }
    while (slotStart.getHours() < dayEndHour || (slotStart.getHours() === dayEndHour && slotStart.getMinutes() === 0)) {
      const slotEnd = new Date(slotStart.getTime() + 60 * 60 * 1000);
      if (slotEnd.getHours() > dayEndHour || (slotEnd.getHours() === dayEndHour && slotEnd.getMinutes() > 0)) break;
      const hasOverlap = dayReservations.some((r) => {
        const rStart = new Date(r.startTime);
        const rEnd = new Date(r.endTime);
        return rStart < slotEnd && rEnd > slotStart;
      });
      if (!hasOverlap) return { startTime: slotStart, endTime: slotEnd };
      slotStart = new Date(slotStart.getTime() + 30 * 60 * 1000);
    }
    return null;
  }

  for (let hour = dayStartHour; hour < dayEndHour; hour++) {
    const slotStart = new Date(dateNorm);
    slotStart.setHours(hour, 0, 0, 0);
    const slotEnd = new Date(dateNorm);
    slotEnd.setHours(hour + 1, 0, 0, 0);

    const hasOverlap = dayReservations.some((r) => {
      const rStart = new Date(r.startTime);
      const rEnd = new Date(r.endTime);
      return rStart < slotEnd && rEnd > slotStart;
    });

    if (!hasOverlap) {
      return { startTime: slotStart, endTime: slotEnd };
    }
  }
  return null;
};

export const getWeekDays = (currentDate: Date): Date[] => {
  const startOfWeek = new Date(currentDate);
  const day = startOfWeek.getDay();
  const diff = startOfWeek.getDate() - day + (day === 0 ? -6 : 1);
  startOfWeek.setDate(diff);

  const weekDays: Date[] = [];
  for (let i = 0; i < 7; i++) {
    const d = new Date(startOfWeek);
    d.setDate(startOfWeek.getDate() + i);
    weekDays.push(d);
  }
  return weekDays;
};

export const isToday = (date: Date): boolean => {
  const today = new Date();
  return date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate();
};

export const isPastDay = (day: Date): boolean => {
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);
  const dayStart = new Date(day.getFullYear(), day.getMonth(), day.getDate());
  return dayStart < todayStart;
};
